import React from "react";

function Order({ colorCode = "" }) {
  return (
    <svg
      className="MuiSvgIcon-root"
      viewBox="0 0 20 18"
      style={{ fill: "transparent" }}
    >
      <path
        d="M8.66634 5.74992H14.6663C14.8211 5.74992 14.9694 5.68846 15.0788 5.57906C15.1882 5.46967 15.2497 5.3213 15.2497 5.16659C15.2497 5.01188 15.1882 4.8635 15.0788 4.75411C14.9694 4.64471 14.8211 4.58325 14.6663 4.58325H8.66634C8.51163 4.58325 8.36326 4.64471 8.25386 4.75411C8.14447 4.8635 8.08301 5.01188 8.08301 5.16659C8.08301 5.3213 8.14447 5.46967 8.25386 5.57906C8.36326 5.68846 8.51163 5.74992 8.66634 5.74992Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.5"
      ></path>
      <path
        d="M14.6663 8.4165H8.66634C8.51163 8.4165 8.36326 8.47796 8.25386 8.58736C8.14447 8.69675 8.08301 8.84513 8.08301 8.99984C8.08301 9.15455 8.14447 9.30292 8.25386 9.41232C8.36326 9.52171 8.51163 9.58317 8.66634 9.58317H14.6663C14.8211 9.58317 14.9694 9.52171 15.0788 9.41232C15.1882 9.30292 15.2497 9.15455 15.2497 8.99984C15.2497 8.84513 15.1882 8.69675 15.0788 8.58736C14.9694 8.47796 14.8211 8.4165 14.6663 8.4165Z"
        fill={colorCode}
        stroke={"#51CBFF"}
        strokeWidth="0.5"
      ></path>
      <path
        d="M6.16667 6.33333C6.811 6.33333 7.33333 5.811 7.33333 5.16667C7.33333 4.52233 6.811 4 6.16667 4C5.52233 4 5 4.52233 5 5.16667C5 5.811 5.52233 6.33333 6.16667 6.33333Z"
        fill={colorCode}
      ></path>
      <path
        d="M6.16667 10.1666C6.811 10.1666 7.33333 9.64425 7.33333 8.99992C7.33333 8.35559 6.811 7.83325 6.16667 7.83325C5.52233 7.83325 5 8.35559 5 8.99992C5 9.64425 5.52233 10.1666 6.16667 10.1666Z"
        fill={"#51CBFF"}
      ></path>
      <path
        d="M6.16667 14.0001C6.811 14.0001 7.33333 13.4777 7.33333 12.8334C7.33333 12.1891 6.811 11.6667 6.16667 11.6667C5.52233 11.6667 5 12.1891 5 12.8334C5 13.4777 5.52233 14.0001 6.16667 14.0001Z"
        fill={colorCode}
      ></path>
      <path
        d="M14.6663 12.25H8.66634C8.51163 12.25 8.36326 12.3115 8.25386 12.4209C8.14447 12.5303 8.08301 12.6786 8.08301 12.8333C8.08301 12.988 8.14447 13.1364 8.25386 13.2458C8.36326 13.3552 8.51163 13.4167 8.66634 13.4167H14.6663C14.8211 13.4167 14.9694 13.3552 15.0788 13.2458C15.1882 13.1364 15.2497 12.988 15.2497 12.8333C15.2497 12.6786 15.1882 12.5303 15.0788 12.4209C14.9694 12.3115 14.8211 12.25 14.6663 12.25Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.5"
      ></path>
      <rect
        x="1"
        y="1"
        width="18"
        height="16"
        rx="2"
        stroke={colorCode}
        strokeWidth="2"
      ></rect>
    </svg>
  );
}

export default Order;
